import React, { useState, useEffect, useRef } from 'react';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import neshan from '../../api/neshan';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import pin from '../../assets/svg/greenPin.svg';
// import { categries, typies } from '../../api/neshan';

import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconUrl: pin,
});

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 1),
  },
  searchBox: {
    flex: 1,
  },
  popover: {
    padding: theme.spacing(1),
  },
  resultBox: {
    position: 'absolute',
    top: '98px',
    right: '10%',
    width: '80%',
    zIndex: 1000,
  },
  resultPaper: {
    padding: theme.spacing(1),
  },
  resultListBox: {
    maxHeight: '50vh',
    overflowY: 'auto',
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PinOnMap = ({
  position,
  marker,
  open,
  setMarker,
  setPosition,
  onClose,
}) => {
  const classes = useStyles();
  const [search, setSearch] = useState(null);
  const [searching, setSearching] = useState(false);
  const [searchResult, setSearchResult] = useState(null);
  const [zoom, setZoom] = useState(5);
  if (!position) {
    position = [32.048241, 54.380117];
  }
  var timer = useRef(null);
  const mapRef = useRef();
  const handleClick = (e) => {
    const latlng = Object.entries(e.latlng).map((l) => l[1]);
    setMarker(latlng);
    setPosition(latlng);
    zoom <= 12 && setZoom(17);
    onClose();
  };

  const pin = (
    <Marker position={marker}>
      <Popup>شما این نقطه را انتخاب کرده اید</Popup>
    </Marker>
  );

  const handleClose = () => {
    onClose();
  };
  const handleSearch = (e) => {
    const { value } = e.target;
    setSearch(value);
  };
  const searchProgress = async () => {
    setSearching(true);
    try {
      const { data } = await neshan.get(
        `/v1/search?term=${search}&lat=${position[0]}&lng=${position[1]}`
      );
      data && setSearchResult(data);
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
    }
    setSearching(false);
  };
  const handleCloseResults = () => {
    setSearchResult(null);
    setSearching(false);
  };
  const handleSetPosition = (latlng, category) => {
    setPosition(latlng);
    if (category === 'region') {
      setZoom(12);
    } else {
      setZoom(17);
    }
  };

  useEffect(() => {
    clearTimeout(timer.current);
    !search && handleCloseResults();
    if (search) {
      timer.current = setTimeout(() => searchProgress(), 500);
    }
  }, [search]);

  let searchICON = null;
  if (!searching && searchResult !== null) {
    searchICON = (
      <IconButton onClick={() => setSearch('')}>
        <CloseIcon />
      </IconButton>
    );
  } else if (searching) {
    searchICON = <CircularProgress />;
  } else {
    searchICON = (
      <IconButton>
        <SearchIcon />
      </IconButton>
    );
  }

  return (
    <>
      {' '}
      <Dialog
        fullWidth
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <div style={{ position: 'relative', height: 500 }}>
          <div
            style={{
              width: '80%',
              margin: '20px auto',
              position: 'absolute',
              top: '5px',
              right: '10%',
              zIndex: '1000',
              padding: '10px 0',
            }}
          >
            <Paper elevation={3} className={classes.root}>
              <InputBase
                fullWidth
                className={classes.searchBox}
                placeholder="جستجو آدرس"
                autoFocus
                onChange={handleSearch}
                value={search ? search : ''}
              />

              {searchICON}
            </Paper>
          </div>
          {searchResult !== null && (
            <ClickAwayListener onClickAway={() => setSearch('')}>
              <div className={classes.resultBox}>
                <Paper elevation={3} className={classes.resultPaper}>
                  {searchResult.count === 0 &&
                    'موردی یافت نشد! عبارت جستجو بهتر است شامل: استان، نام شهر، نام معبر یا خیابان باشد.'}
                  {searchResult.count > 0 && (
                    <List className={classes.resultListBox}>
                      {searchResult.items.map((result, index) => (
                        <ListItem
                          button
                          key={index}
                          onClick={() => {
                            handleSetPosition(
                              [result.location.y, result.location.x],
                              result.category
                            );
                            setSearch('');
                          }}
                        >
                          <ListItemText
                            primary={result.title}
                            secondary={`${result.region} ${
                              !!result.address
                                ? '| آدرس: ' + result.address
                                : ''
                            }`}
                          />
                        </ListItem>
                      ))}
                    </List>
                  )}
                </Paper>
              </div>
            </ClickAwayListener>
          )}
          <Map
            center={position}
            length={4}
            onClick={handleClick}
            ref={mapRef}
            zoom={zoom}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            {marker && pin}
          </Map>
        </div>

        <DialogActions>
          <Button
            fullWidth
            size="large"
            variant="contained"
            color="primary"
            onClick={handleClose}
          >
            بستن
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PinOnMap;
